module.exports = __webpack_public_path__ + "static/media/FarleyGnu.de99912d.png";